import { FormInput } from "../../components/molecules/FormInput";
import { FormSelect } from "../../components/atoms/FormSelect";
import { useFieldArray } from "react-hook-form";
import { FormDiv } from "../../components/atoms/FormDiv";

export const NuevoHorarioFormCard = ({
  control,
  register,
  horarios = [],
  errors = {},
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "horarioAulas",
  });

  const agregarHorarioAula = () => {
    append({ idHorario: null, nroAula: "" });
  };

  return (
    <div>
      <h3 className="font-bold text-blue-500 mb-3">Horarios</h3>

      {fields.map((field, index) => (
        <FormDiv key={field.id} className="md:flex items-center mb-4 border p-3 rounded-lg shadow-sm bg-gray-50">
          <FormSelect
            name={`horarioAulas.${index}.idHorario`}
            label="Horario"
            control={control}
            options={horarios}
            validation={{ required: "Campo requerido" }}
            placeholder="Selecciona un horario"
            error={errors?.horarioAulas?.[index]?.idHorario}
            className="md:w-3/4 md:pr-4"
          />
          <button
            type="button"
            onClick={() => remove(index)}
            className="mt-2 md:mt-0 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
          >
            Eliminar
          </button>
        </FormDiv>
      ))}

      <div className="flex justify-center mt-4">
        <button
          type="button"
          onClick={agregarHorarioAula}
          className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded shadow"
        >
          Agregar nuevo horario
        </button>
      </div>
    </div>
  );
};
